<template>
    <div class="rehab_all_list">
        <ListTable
            :headerItems="headerItems"
            :itemRows="itemRowsProps"
        />
        <infinite-loading
            @infinite="infiniteHandler"
            force-use-infinite-wrapper=".rehab_all_list"
            :identifier="moreData"
        >
            <div slot="spinner" class="mt30">{{$t('table.list.loading')}}</div>
            <div slot="no-more" class="mt30">{{$t('table.list.end_result')}}</div>
            <div slot="no-results" class="mt30">{{itemRowsProps.length === 0 ? $t('table.list.no_result') : $t('table.list.end_result')}}</div>
        </infinite-loading>
    </div>
</template>

<script>
import ListTable from '../../../../Table/listTable'

export default {
  components: {
    ListTable,
  },
  props: [
    'itemRowsProps',
    'selectedCategoryStatus',
    'device',
  ],
  data() {

    return {
      // headerItems: [
      //   {
      //     index: 0,
      //     keyTitle: this.$t('user.name'),
      //     keyType: 'HeaderDefault',
      //     parentClass: [],
      //     componentOptions: {},
      //     keyRange: [],
      //     values: 3,
      //     click: (event, item) => {
      //       this.$emit(`orderBy`, event, item)
      //     }
      //   },
      //   {
      //     index: 1,
      //     keyTitle: this.$t('title'),
      //     keyType: 'HeaderDefault',
      //     parentClass: [],
      //     componentOptions: {},
      //     keyRange: [],
      //     values: 0,
      //     click: (event, item) => {
      //       this.$emit(`orderBy`, event, item)
      //     }
      //   },
      //   {
      //     index: 2,
      //     keyTitle: this.$t('status.status'),
      //     keyType: 'HeaderDefault',
      //     parentClass: [],
      //     componentOptions: {},
      //     keyRange: [],
      //     values: 2,
      //     // click: (event, item) => {
      //     //   this.$emit(`orderBy`, event, item)
      //     // }
      //   },
      //   {
      //     index: 3,
      //     keyTitle: this.$t('rehabilitation.mode'),
      //     keyType: 'HeaderDefault',
      //     parentClass: [],
      //     componentOptions: {},
      //     keyRange: [],
      //     values: '',
      //   },
      //   {
      //     index: 4,
      //     keyTitle: this.$t('rehabilitation.exercise_position'),
      //     keyType: 'HeaderDefault',
      //     parentClass: [],
      //     componentOptions: {},
      //     keyRange: [],
      //     values: '',
      //   },
      //   {
      //     index: 5,
      //     keyTitle: this.$t('rehabilitation.exercise_method'),
      //     keyType: 'HeaderDefault',
      //     parentClass: [''],
      //     componentOptions: {},
      //     keyRange: [],
      //     values: '',
      //   },
      //   {
      //     index: 6,
      //     keyTitle: this.$t('rehabilitation.device_height'),
      //     keyType: 'HeaderDefault',
      //     parentClass: [''],
      //     componentOptions: {},
      //     keyRange: [],
      //     values: '',
      //   },
      //   {
      //     index: 7,
      //     keyTitle: this.$t('rehabilitation.set'),
      //     keyType: 'HeaderDefault',
      //     parentClass: [],
      //     componentOptions: {},
      //     keyRange: [],
      //     values: '',
      //   },
      //   {
      //     index: 8,
      //     keyTitle: this.$t('rehabilitation.due_date'),
      //     keyType: 'HeaderDefault',
      //     parentClass: [],
      //     componentOptions: {},
      //     keyRange: [],
      //     values: 1,
      //     click: (event, item) => {
      //       this.$emit(`orderBy`, event, item)
      //     }
      //   }
      // ],
      headerItems: [],
      moreData: +new Date()
    }
  },
  beforeMount(){
    this.setDataTableHeader();
  },
  methods: {
    infiniteHandler($state) {
      this.$emit(`getAllMyPatientExerciseHistoryByLimit`, null, (isSuccess, errCode, errLog) => {
        if (isSuccess) {
          $state.loaded();
        } else {
          if (errCode === 1) {
            $state.complete();
          } else {
            console.error(errCode, errLog);
            $state.error();
          }
        }
      })
    },
    setDataTableHeader(device = this.device, selectedCategoryStatus = this.selectedCategoryStatus) {
      if (selectedCategoryStatus !== 6) {
        const setDeviceHeader = () => {
          if (device === 1) {
            return [
              {
                index: 5,
                keyTitle: this.$t('rehabilitation.exercise_method'),
                keyType: 'HeaderDefault',
                parentClass: [''],
                componentOptions: {},
                keyRange: [],
                values: '',
              },
              {
                index: 6,
                keyTitle: this.$t('rehabilitation.device_height'),
                keyType: 'HeaderDefault',
                parentClass: [''],
                componentOptions: {},
                keyRange: [],
                values: '',
              },
            ];
          } else {
            return [
              // {
              //   index: 5,
              //   keyTitle: this.$t('rehabilitation.resistance_sensitivity'),
              //   keyType: 'HeaderDefault',
              //   parentClass: [''],
              //   componentOptions: {},
              //   keyRange: [],
              //   values: '',
              // },
            ];
          }
        }
        const tempHeader = setDeviceHeader();

        this.headerItems = [
          {
            index: 0,
            keyTitle: this.$t('user.name'),
            keyType: 'HeaderDefault',
            parentClass: [],
            componentOptions: {},
            keyRange: [],
            values: 3,
            click: (event, item) => {
              this.$emit(`orderBy`, event, item)
            }
          },
          {
            index: 1,
            keyTitle: this.$t('title'),
            keyType: 'HeaderDefault',
            parentClass: [],
            componentOptions: {},
            keyRange: [],
            values: 0,
            click: (event, item) => {
              this.$emit(`orderBy`, event, item)
            }
          },
          {
            index: 2,
            keyTitle: this.$t('status.status'),
            keyType: 'HeaderDefault',
            parentClass: [],
            componentOptions: {},
            keyRange: [],
            values: 2,
            // click: (event, item) => {
            //   this.$emit(`orderBy`, event, item)
            // }
          },
          {
            index: 3,
            keyTitle: this.$t('rehabilitation.mode'),
            keyType: 'HeaderDefault',
            parentClass: [],
            componentOptions: {},
            keyRange: [],
            values: '',
          },
          {
            index: 4,
            keyTitle: this.$t('rehabilitation.exercise_position'),
            keyType: 'HeaderDefault',
            parentClass: [],
            componentOptions: {},
            keyRange: [],
            values: '',
          },
          ...tempHeader,
          {
            index: 7,
            keyTitle: this.$t('rehabilitation.set'),
            keyType: 'HeaderDefault',
            parentClass: [],
            componentOptions: {},
            keyRange: [],
            values: '',
          },
          {
            index: 8,
            keyTitle: this.$t('rehabilitation.due_date'),
            keyType: 'HeaderDefault',
            parentClass: [],
            componentOptions: {},
            keyRange: [],
            values: 1,
            click: (event, item) => {
              this.$emit(`orderBy`, event, item)
            }
          }
        ];
      } else {
        const setDeviceHeader = () => {
          if (device === 1) {
            return [
              {
                index: 4,
                keyTitle: `${this.$t('rehabilitation.min_rom')} ~ ${this.$t('rehabilitation.max_rom')}`,
                keyType: 'HeaderDefault',
                parentClass: [],
                componentOptions: {},
                keyRange: [],
                values: '',
              },
              {
                index: 5,
                keyTitle: `${this.$t('rehabilitation.down')} / ${this.$t('rehabilitation.up')}`,
                keyType: 'HeaderDefault',
                parentClass: [],
                componentOptions: {},
                keyRange: [],
                values: '',
              },
              {
                index: 6,
                keyTitle: `${this.$t('rehabilitation.repeats')}`,
                keyType: 'HeaderDefault',
                parentClass: [],
                componentOptions: {},
                keyRange: [],
                values: '',
              },
              {
                index: 7,
                keyTitle: `${this.$t('rehabilitation.time')}`,
                keyType: 'HeaderDefault',
                parentClass: [],
                componentOptions: {},
                keyRange: [],
                values: '',
              },
            ];
          } else {
            return [
              {
                index: 5,
                keyTitle: `${this.$t('rehabilitation.down')} / ${this.$t('rehabilitation.up')}`,
                keyType: 'HeaderDefault',
                parentClass: [],
                componentOptions: {},
                keyRange: [],
                values: '',
              },
              {
                index: 6,
                keyTitle: this.$t('rehabilitation.delay'),
                keyType: 'HeaderDefault',
                parentClass: [],
                componentOptions: {},
                keyRange: [],
                values: '',
              },
              {
                index: 7,
                keyTitle: this.$t('rehabilitation.max'),
                keyType: 'HeaderDefault',
                parentClass: [],
                componentOptions: {},
                keyRange: [],
                values: '',
              },
            ];
          }
        }
        const tempHeader = setDeviceHeader();

        this.headerItems = [
          {
            index: 0,
            keyTitle: this.$t('user.name'),
            keyType: 'HeaderDefault',
            parentClass: [],
            componentOptions: {},
            keyRange: [],
            values: 2,
            click: (event, item) => {
              this.$emit(`orderBy`, event, item)
            }
          },
          {
            index: 1,
            keyTitle: this.$t('rehabilitation.duration'),
            keyType: 'HeaderDefault',
            parentClass: [],
            componentOptions: {},
            keyRange: [],
            values: 0,
            click: (event, item) => {
              this.$emit(`orderBy`, event, item)
            }
          },
          {
            index: 2,
            keyTitle: this.$t('rehabilitation.mode'),
            keyType: 'HeaderDefault',
            parentClass: [],
            componentOptions: {},
            keyRange: [],
            values: 1,
            // click: (event, item) => {
            //   this.$emit(`orderBy`, event, item)
            // }
          },
          {
            index: 3,
            keyTitle: this.$t('rehabilitation.exercise_position'),
            keyType: 'HeaderDefault',
            parentClass: [],
            componentOptions: {},
            keyRange: [],
            values: '',
          },
          ...tempHeader,
          {
            index: 99,
            keyTitle: this.$t('rehabilitation.speed'),
            keyType: 'HeaderDefault',
            parentClass: [],
            componentOptions: {},
            keyRange: [],
            values: '',
          },
        ];
      }
    }
  },
  watch: {
    itemRowsProps: {
      deep: true,
      handler(newValue, oldValue) {
        if (newValue.length === 0 || JSON.stringify(newValue) !== JSON.stringify(oldValue))
          this.moreData += 1;
      }
    },
    selectedCategoryStatus() {
      this.setDataTableHeader();
    },
    device: {
      deep: true,
      handler(newValue, oldValue) {
        if (newValue !== oldValue) {
          this.setDataTableHeader(newValue);
        }
      }
    },
  }
}
</script>
<style lang="scss">
.rehab_all_list {
  overflow: auto;

  .table-container {
    .table-header {
      position: sticky;
      top: 0;
      background: #f7f7f7;

      .item-value:first-child {
        flex-grow: 4;
      }

      .item-value:nth-child(2) {
        flex-grow: 7;
      }

      .item-value:nth-child(3) {
        flex-grow: 4;
      }
    }

    .item-parent {
      margin: 0;
    }

    .table-body {
      .item-value:first-child {
        flex-grow: 4;
      }

      .item-value:nth-child(2) {
        flex-grow: 7;
      }

      .item-value:nth-child(3) {
        flex-grow: 4;
      }
    }
  }
}
</style>
